export default __webpack_public_path__ + "img/final1-2e6b1e49.png";